import React from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../assets/icons/appstore.svg';
import AppStoreNL from '../../assets/icons/appstore-nl.svg';
import PlayStore from '../../assets/icons/playstore.svg';
import PlayStoreNL from '../../assets/icons/playstore-nl.svg';
import Icon from '../../assets/icons/DIGID.svg';
import { useTranslation } from 'react-i18next';
import BackgroundImage from 'gatsby-background-image'

function checkForMobile(appStore, playStore) {
  if (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  ) {
    const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (iOS) {
      window.location.href = appStore;
    } else {
      window.location.href = playStore;
    }
  }
  return;
}

const DigidApp = React.memo(({ appStore, playStore, title, text, backgroundImage }) => {
  const { i18n } = useTranslation();

  return (
    <BackgroundImage
      onClick={() => {
        checkForMobile(appStore, playStore);
      }}
      fadeIn={false}
      className="app-block"
      {...backgroundImage}
    >
      <div className="logo">
        <Icon />
      </div>
      <div>
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      <div className="button-group">
        <a href={appStore} target="_blank" rel="noopener noreferrer">
          {(i18n.language.toLowerCase() == 'nl' ? <AppStoreNL /> : <AppStore />)}
        </a>
        <a href={playStore} target="_blank" rel="noopener noreferrer">
          {(i18n.language.toLowerCase() == 'nl' ? <PlayStoreNL /> : <PlayStore />)}
        </a>
      </div>
    </BackgroundImage>
  );
});

DigidApp.defaultProps = {
  appStore: 'https://itunes.apple.com/us/app/digid/id1208460960?ls=1&mt=8',
  playStore: 'https://play.google.com/store/apps/details?id=nl.rijksoverheid.digid.pub',
  title: 'Download de DigiD app',
  text: 'En laat nóg makkelijker zien wie je bent',
};

DigidApp.propTypes = {
  appStore: PropTypes.string.isRequired,
  playStore: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default DigidApp;
